export default __webpack_public_path__ + "static/media/NorthernBorders.00fa2848.mp4";